<template>
  <div class="navbar_btn">
    <img v-if="common.holidayStyle>0" class="navbar_btnbg" :src="require('../assets/images/navbar/holiday_'+$store.state.common.holidayStyle+'/navber_bg.jpg')" />
    <router-link
      tag="div"
      to="/"
      :class="['navbar_list',tab==0 ? 'cur' :'']"
    >
       <img v-if="common.holidayStyle>0" class="theme_2img" :src="tab==0 ?require('../assets/images/navbar/holiday_'+$store.state.common.holidayStyle+'/homeS.png'):require('../assets/images/navbar/holiday_'+$store.state.common.holidayStyle+'/home.png')"/>
       <img v-else class="theme_img" :src="tab==0 ?require('../assets/images/navbar/navbar_'+$store.state.common.theme+'/homeS.png'):require('../assets/images/navbar/navbar_'+$store.state.common.theme+'/home.png')">
       <div v-if="common.holidayStyle>0" class="theme_2span">首页</div>
       <span v-else>首页</span>
    </router-link>
    <router-link
      tag="div"
      to="/activity"
      :class="['navbar_list',tab==1 ? 'cur' :'']"
    >
     <img v-if="common.holidayStyle>0" class="theme_2img" :src="tab==1 ?require('../assets/images/navbar/holiday_'+$store.state.common.holidayStyle+'/discoverS.png'):require('../assets/images/navbar/holiday_'+$store.state.common.holidayStyle+'/discover.png')"/>
     <img v-else class="theme_img"   :src="tab==1 ?require('../assets/images/navbar/navbar_'+$store.state.common.theme+'/discoverS.png'):require('../assets/images/navbar/navbar_'+$store.state.common.theme+'/discover.png')">
     <div v-if="common.holidayStyle>0" class="theme_2span">发现</div>
      <span v-else>发现</span>
    </router-link>
    <router-link
      tag="div"
      to="/smartOffice"
      v-if="common.userTenantInfo && common.userTenantInfo.companyId == '675' || common.userTenantInfo.companyId == '1' || common.userTenantInfo.companyId == '103'"
      :class="['navbar_list',tab==2 ? 'cur' :'']"
    >
     <img class="smart_office" :src="tab==2 ?require('../assets/images/navbar/icon_tab_smart_s.png'):require('../assets/images/navbar/icon_tab_smart_n.png')">
      <span :class="[common.holidayStyle>0?'white':'']">智慧办公</span>
    </router-link>
    <router-link
      tag="div"
      to="/me"
      :class="['navbar_list',tab==3 ? 'cur' :'']"
    >
       <img v-if="common.holidayStyle>0" class="theme_2img" :src="tab==3 ?require('../assets/images/navbar/holiday_'+$store.state.common.holidayStyle+'/myS.png'):require('../assets/images/navbar/holiday_'+$store.state.common.holidayStyle+'/my.png')"/>
       <img v-else class="theme_img" :src="tab==3 ?require('../assets/images/navbar/navbar_'+$store.state.common.theme+'/myS.png'):require('../assets/images/navbar/navbar_'+$store.state.common.theme+'/my.png')">
       <div v-if="common.holidayStyle>0" class="theme_2span">我的</div>
      <span v-else>我的</span>
    </router-link>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'navBar',
  props: {
    tab:{
      type:Number,
      default:0
    },
  },
  data () {
    return {
      navList: [],
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created () {
  },

  methods: {}
};
</script>
<style lang="less" scoped>
@import "../assets/css/common.less";
.navbar_btn {
  .flex();
  justify-content: center;
  width: 100%;
  height: 1rem;
  margin:0 auto;
  background: #fff;
  box-shadow: 0px 0px .18rem 0px rgba(0, 0, 0, 0.05);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index:100;
  .navbar_btnbg{
    position:absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index:100;
  }
  .navbar_list {
    .flex();
    flex-direction: column;
    flex: 1;
    z-index:1000;
    align-items: center;
    .theme_img {
      display: block;
      width: .48rem;
      height: .48rem;
      margin-top:14px;
      margin-bottom:2px;
    }
    .theme_2img{
      width:56px;
      height:56px;
      margin-top:8px;
    }
    span {
      height:.28rem;
      font-size:.2rem;
      line-height:.28rem;
      color:@color99;
    }
    .smart_office{
      width:60px;
      height:60px;
      margin-top:6px;
      margin-bottom:0;
      .white{
        color:#fff !important;
      }
    }
    &.cur {
      span{
        color: #333;
      }
      .smart_office{
        .white{
          color:#fff !important;
        }
      }
    }
  }
}
.theme_2span{
   height:.28rem;
   font-size:.2rem;
   line-height:.28rem;
    color:#ffffff;

}
.white{
  color:#fff !important;
}

</style>
